import { IndividualCounselingProjectForm } from "./Main";

export const Register = () => {
  return <IndividualCounselingProjectForm />;
};
